export default function closestValueIndex(arr: number[], target: number) {
  let minIndex = 0;
  let maxIndex = arr.length - 1;

  if (!arr.length) return null;
  if (maxIndex === 0) return maxIndex;
  if (arr[minIndex]! >= target) return minIndex;
  if (arr[maxIndex]! <= target) return maxIndex;

  let guessIndex; // number between minIndex and maxIndex, not included

  while (minIndex <= maxIndex) {
    guessIndex = Math.floor((maxIndex + minIndex) / 2);

    if (arr[guessIndex] === target) return guessIndex;
    if (arr[guessIndex]! < target) {
      minIndex = guessIndex + 1;
    } else {
      maxIndex = guessIndex - 1;
    }
  }

  return Math.abs(arr[minIndex]! - target) <= Math.abs(arr[maxIndex]! - target)
    ? minIndex
    : maxIndex;
}
